import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import VideoPlayer from "@/components/VideoPlayer";

export default function HeroSection() {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white py-16 sm:py-24" data-id="pwykixpll" data-path="src/components/home/HeroSection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="cwj0ntg9k" data-path="src/components/home/HeroSection.tsx">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="nc49ohl9k" data-path="src/components/home/HeroSection.tsx">
          <div data-id="7uko7d0w3" data-path="src/components/home/HeroSection.tsx">
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 mb-6" data-id="cjnr5uu40" data-path="src/components/home/HeroSection.tsx">
              <span className="block" data-id="ycvgw7tm5" data-path="src/components/home/HeroSection.tsx">Automate Your Business</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="tk1u1wn03" data-path="src/components/home/HeroSection.tsx">
                With AI-Powered Solutions
              </span>
            </h1>
            
            <p className="text-lg text-gray-600 mb-8" data-id="1gc54y3dz" data-path="src/components/home/HeroSection.tsx">
              We help businesses save time, reduce manual work, and streamline operations with AI-powered automation. Integrate your business tools with our custom solutions.
            </p>
            
            <div className="flex flex-wrap gap-4" data-id="uxro8b5ac" data-path="src/components/home/HeroSection.tsx">
              <Button asChild size="lg" className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700" data-id="r0nz6vp62" data-path="src/components/home/HeroSection.tsx">
                <Link to="/contact" data-id="kpe2vd0g0" data-path="src/components/home/HeroSection.tsx">Get Started</Link>
              </Button>
              
              <Button asChild size="lg" className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 group" data-id="w7f6whe90" data-path="src/components/home/HeroSection.tsx">
                <Link to="/use-cases" className="flex items-center" data-id="rhyazfkwt" data-path="src/components/home/HeroSection.tsx">
                  Explore Use Cases
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="4a0kdg6af" data-path="src/components/home/HeroSection.tsx" />
                </Link>
              </Button>
            </div>
          </div>
          
          <div className="relative" data-id="f55v80ie6" data-path="src/components/home/HeroSection.tsx">
            <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="h60ql9b4h" data-path="src/components/home/HeroSection.tsx">
              <VideoPlayer
                src="https://cdn.ezsite.ai/AutoDev/28385/554785d7-ee09-47f6-99bf-9c5b3362d909.mp4"
                className="" data-id="h3kphgqln" data-path="src/components/home/HeroSection.tsx" />

              <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/40 to-purple-600/40 mix-blend-overlay pointer-events-none" data-id="w1iur47cq" data-path="src/components/home/HeroSection.tsx"></div>
            </div>
            
            {/* Feature badges */}
            



            
            



          </div>
        </div>
      </div>
    </div>);

}